import { Page } from '@/pages/TechnicianPage/hooks/useTechnicianDocument'

export const findSubPageIndex = (page: Page) => {
  const subPages = (page.template_values?.subPages || []) as string[]
  const index = subPages.findIndex((id) => id === page.subPageId)
  return index >= 0 ? index : undefined
}
